/**
 * Logo — Phase 6a.2 placeholder per spec §9.1.
 *
 * 40×40 EY-yellow square with "I16" in bold. Future swap point: replace
 * the <div> with <img src="/logo.svg" /> when the real logo is ready.
 */
export function Logo() {
  return (
    <img
      src="/qlogo512.png"
      alt="Quanitra"
      className="h-10 w-10 shrink-0 rounded-md object-contain select-none transition-all group-data-[collapsible=icon]:h-7 group-data-[collapsible=icon]:w-7"
      draggable={false}
    />
  );
}
